/*
 * File: index.ts
 * File Created: 2024-02-02 07:43:38
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-12-23 06:27:51
 * Modified By: Val Liu
 * -----
 */

// import { ALLOW_GENERAL_MODIFY, ALLOW_GENERAL_READ } from "@/helpers/permission-helper";
import { PARAMS_INCLUDE, PARAMS_WHERE } from "@/views/core";
import { IPermissionCheck, ObjectHelper, Vue } from "@root/core";
import { IQuickUnit, UIQuick } from "@root/core/utilities/quick-helper";
// import { EMonitoringTargetRolePermission } from "shared-taiwan-bank-life-insurance";
const _ = UIQuick.getInstance;

// const rolePermission: EMonitoringTargetRolePermission = EMonitoringTargetRolePermission.系統維護管理作業;

@UIQuick.set()
export class MonitoringTarget extends IQuickUnit {
    title = "w_MonitoringTargetManagement";
    path = "/monitoring-target";
    icon = "fa-solid fa-id-badge";

    /// hireachy
    parents = () => [_`Warrant`];
    children = () => [_`MonitoringTargetDetail`];

    /// file
    file = true;

    // /// toolbox
    // toolboxRead = `<ivc-monitoring-target-toolbox v-bind="$attrs" />`;

    /// params
    paramsWhere = PARAMS_INCLUDE;
    paramsRead = PARAMS_INCLUDE;
    paramsUpdate = PARAMS_INCLUDE;

    /// props
    propsRead = function (this: IQuickUnit): any {
        return {
            interval: 1000,
        };
    };

    /// interfaces
    infDetail = require("raw-loader!./interfaces/monitoring-target.create.interface")
        .default;
    infRead = require("raw-loader!./interfaces/monitoring-target.read.interface").default;
    infCreate = require("raw-loader!./interfaces/monitoring-target.create.interface")
        .default;
    infUpdate = require("raw-loader!./interfaces/monitoring-target.create.interface")
        .default;
    infDelete = require("raw-loader!./interfaces/monitoring-target.delete.interface")
        .default;

    /// auth
    // allowRead = ALLOW_GENERAL_READ(rolePermission);
    // allowCreate = ALLOW_GENERAL_MODIFY(rolePermission);
    // allowUpdate = ALLOW_GENERAL_MODIFY(rolePermission);
    //allowDelete = ALLOW_GENERAL_MODIFY(rolePermission);
}
